import auth from '@/router/auth'
import LessonCreate from '@/components/lessons/Create'
import LessonUpdate from '@/components/lessons/Update'
import LessonShow from '@/components/lessons/Show'

export default [
  {
    path: '/courses/:course_id/chapters/:chapter_id/lessons/create',
    name: 'lessons-create',
    component: LessonCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/lessons/update/:lesson_id',
    name: 'lessons-update',
    component: LessonUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/courses/:course_id/chapters/:chapter_id/lessons/show/:lesson_id',
    name: 'lessons-show',
    component: LessonShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/lessons/router.js